// src/categories/sugar_fast.js
const KEY = "sugar_fast";
const TITLE = "Sugar Detox Sensations";
const SUBTITLE = "A Craving Tongue Sensation";
const MAINWORD = "Craving Tongue";
const MAINWORDS = "craving tongues";
const MIN_ONLINE = 1;
const MAX_ONLINE = 10;


const SENSATIONS = [
  "SUDDEN IRRITABILITY",
  "HEAD PRESSURE",
  "LOW ENERGY DIP",
  "SWEET TOOTH SURGE",
  "LIGHT ANXIETY",
  "BRAIN FOG",
  "MOOD SWINGS",
  "RESTLESS CRAVING",
  "EMPTY-BELLY TUG",
  "MILD NAUSEA",
  "BODY HEAVINESS",
  "MENTAL SNACK LOOP",
  "AFTERNOON CRASH",
];

const DISH_NAMES = {
  "SUDDEN IRRITABILITY": "Irritable Wave",
  "HEAD PRESSURE": "Head Tightness",
  "LOW ENERGY DIP": "Energy Dip",
  "SWEET TOOTH SURGE": "Sweet Surge",
  "LIGHT ANXIETY": "Sugar Anxiety",
  "BRAIN FOG": "Fog Cloud",
  "MOOD SWINGS": "Mood Tide",
  "RESTLESS CRAVING": "Crave Pull",
  "EMPTY-BELLY TUG": "Belly Tug",
  "MILD NAUSEA": "Sugar Nausea",
  "BODY HEAVINESS": "Heavy Body",
  "MENTAL SNACK LOOP": "Snack Loop",
  "AFTERNOON CRASH": "Crash Point",
};

const ENCOURAGEMENTS = {
  "SUDDEN IRRITABILITY":
    "Irritability comes from reduced dopamine stimulation and falling blood sugar as your body adjusts to less sugar.",

  "HEAD PRESSURE":
    "Changes in blood sugar and blood vessel tone can create a temporary pressure-like sensation in the head.",

  "LOW ENERGY DIP":
    "Energy dips happen as your body shifts from quick glucose use to more stable fuel sources like stored glycogen and fat.",

  "SWEET TOOTH SURGE":
    "Cravings are driven by dopamine and habit circuits that were repeatedly activated by sugar intake.",

  "LIGHT ANXIETY":
    "Fluctuating blood sugar and stress hormones can create sensations similar to anxiety.",

  "BRAIN FOG":
    "Your brain is adapting from rapid glucose spikes to steadier energy, which can briefly affect clarity.",

  "MOOD SWINGS":
    "Neurotransmitters like dopamine and serotonin are rebalancing after frequent sugar stimulation.",

  "RESTLESS CRAVING":
    "Habit loops in the brain trigger urges automatically when cues associated with sugar appear.",

  "EMPTY-BELLY TUG":
    "Hunger hormones like ghrelin rise and fall in waves as your eating patterns reset.",

  "MILD NAUSEA":
    "Your digestive system and gut bacteria are adjusting to a lower sugar intake.",

  "BODY HEAVINESS":
    "Temporary low energy and shifting fuel use can make the body feel sluggish or heavy.",

  "MENTAL SNACK LOOP":
    "Memory and reward pathways replay learned behaviors tied to sugar consumption.",

  "AFTERNOON CRASH":
    "Without sugar spikes, your body is adjusting its natural energy rhythm and hormone balance."
};

export default { KEY, TITLE, SUBTITLE, MAINWORDS, MIN_ONLINE, MAX_ONLINE, MAINWORD, SENSATIONS, DISH_NAMES, ENCOURAGEMENTS };
